export default __webpack_public_path__ + "static/decathlon-49990bd82fabf47f5b7e7b4a1c6dfcb4.jpg";